import styled, { css } from 'styled-components';

import { ReactComponent as PillShapeMobile } from '@pkg/assets/icons/v2/pill-shape-mobile.svg';
import { ReactComponent as PillShape } from '@pkg/assets/icons/v2/pill-shape.svg';

import { ChevronDownIcon } from '@app/pages/Prototype/icons';

import { MOBILE_OVERLAP, OVERLAP } from '../../tokens';

interface SmallProps {
    isSmall?: boolean;
}

export const PillInner = styled.div<SmallProps>`
    padding: 2px;
    height: 132px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    transition: transform 0.5s ease;
    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
        `};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;
    }
`;

interface PillMaskProps extends SmallProps {
    hasOnlyOne: boolean;
    showChevron?: boolean;
    showTwitterHandle?: boolean;
    animateTwitterHandle?: boolean;
    twitterHandleLength?: number;
}

export const PillMask = styled.div<PillMaskProps>`
    height: 132px;
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100px;
    margin-left: -${OVERLAP}px;
    transition: all 0.4s ease;

    ${({ showChevron, hasOnlyOne }) =>
        showChevron &&
        css`
            margin-left: calc(-${OVERLAP}px + ${hasOnlyOne ? 30 : 0}px);
            width: 190px;
            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                width: 140px;
                margin-left: calc(-${OVERLAP}px + ${hasOnlyOne ? 40 : 15}px);
            }
        `};

    ${({ showTwitterHandle }) =>
        showTwitterHandle &&
        css`
            width: 100px;
        `};

    ${({ twitterHandleLength, animateTwitterHandle }) =>
        twitterHandleLength &&
        animateTwitterHandle &&
        css`
            margin-left: -${twitterHandleLength < OVERLAP ? twitterHandleLength : OVERLAP + 30}px;
            width: ${twitterHandleLength}px;
            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                margin-left: -${twitterHandleLength < MOBILE_OVERLAP ? twitterHandleLength : MOBILE_OVERLAP}px;
            }
        `};

    ${({ twitterHandleLength, hasOnlyOne }) =>
        twitterHandleLength &&
        hasOnlyOne &&
        css`
            margin-left: -${twitterHandleLength < OVERLAP ? twitterHandleLength : OVERLAP - 30}px;
            width: ${twitterHandleLength - 30}px;

            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                margin-left: -${twitterHandleLength < MOBILE_OVERLAP ? twitterHandleLength - 40 : MOBILE_OVERLAP - 50}px;
                width: ${twitterHandleLength - 40}px;
            }
        `};

    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;
    }
`;

export const Stroke = styled(PillShape)`
    width: 1000px;
    height: 132px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;

export const MobileStroke = styled(PillShapeMobile)`
    display: none;
    height: 66px;
    width: 500px;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

export const StrokeWrapper = styled.div<SmallProps>`
    position: absolute;
    top: 0;
    right: 0;
    width: 1000px;
    height: 132px;
    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
            width: 500px;
        `};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;
        width: 500px;
    }
`;

export const Mask = styled.div<SmallProps>`
    position: absolute;
    top: 0;
    right: 0;
    width: 1000px;
    height: 132px;
    background: rgba(255, 255, 255, 0.05);
    clip-path: url(#pillshapemask);
    transform: translateY(2px);

    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
            width: 500px;
            clip-path: url(#pillshapemaskmobile);
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;
        width: 500px;
        clip-path: url(#pillshapemaskmobile);
    }
`;

export const TwitterHandle = styled.h3<SmallProps>`
    font-size: 50px;
    color: #3aa8f2;
    letter-spacing: -2px;
    font-family: 'Alliance No.1';
    text-align: right;
    margin: 0;
    top: 47%;
    transform: translateY(-50%);
    right: 35px;
    position: absolute;

    ${({ isSmall }) =>
        isSmall &&
        css`
            font-size: 26px;
            letter-spacing: -1px;
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 35px;
        letter-spacing: -1px;

        ${({ isSmall }) =>
            isSmall &&
            css`
                font-size: 28px;
            `};
    }
`;

export const Chevron = styled(ChevronDownIcon)<SmallProps>`
    width: 22px;
    height: 13px;
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    fill: transparent;

    ${({ isSmall }) =>
        isSmall &&
        css`
            width: 16px;
            height: 9px;
            right: 24px;
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 16px;
        height: 9px;
        right: 24px;
    }
`;
